import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from "react-toastify"

import useDidMountEffect from 'pages/parts/useDidMountEffect'
import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, GET, DELETE, FILE_D, PUT, FILE } from 'helpers/api'
import { findKeyFromArrayByValue, formatMoney, returnSign, PAGE_SIZES } from "helpers/helpers"
import CustomTooltip from "pages/parts/CustomTooltip"

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const statuses = [
		{ "id": 1, "name": t('success') },
		{ "id": -1, "name": t('deleted') },
	]

	const columnFilers = [
		{ "id": 'fiscal', "name": t('fiscalization') },
		{ "id": 'menu', "name": t('menu') },
		{ "id": 'preparation_place', "name": t('preparation_places') },
		{ "id": 'image', "name": t('image2') },
		{ "id": 'telegram_bot', "name": t('external_service') },
		{ "id": 'ingredients', "name": t('ingredients') },
	]

	const columnOrders = [
		{ 'id': 'name,asc', 'name': `${t('name2')} ↑` },
		{ 'id': 'name,desc', 'name': `${t('name2')} ↓` },
	]

	const [data, setData] = useState([])
	const [menu, setMenu] = useState([])
	const [poses, setPoses] = useState([])
	const [productTypes, setProductTypes] = useState([])
	const [preparationPlaces, setPreparationPlaces] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalCostPrice, setModalCostPrice] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		'pos_id': reduxAccount.pos_id,
		'wms_id': reduxAccount.wms_id,
		'in_product': 1,
		'status': 1,
		'size': 20,
		'search': '',
	})
	const [pagination, setPagination] = useState({
		url: '/products',
		size: 20,
		response: null
	})

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/products"
		var urlParams = ""
		checkFilter()

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.order_by)
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.product_without)
			urlParams += returnSign(urlParams) + 'product_without=' + filterDataCopy.product_without
		if (filterDataCopy.menu_id)
			urlParams += returnSign(urlParams) + 'menu_id=' + filterDataCopy.menu_id
		if (filterDataCopy.preparation_place_id)
			urlParams += returnSign(urlParams) + 'preparation_place_id=' + filterDataCopy.preparation_place_id
		if (filterDataCopy.in_product >= 0)
			urlParams += returnSign(urlParams) + 'in_product=' + filterDataCopy.in_product
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (passedData['excel']) {
			urlParams += returnSign(urlParams) + 'excel=true'

			const responseExcel = await FILE_D(filterUrl + urlParams)
			if (httpOk(responseExcel)) {
				// Создаем объект Blob из полученного файла
				const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Создаем ссылку для скачивания файла
				const fileUrl = URL.createObjectURL(file);

				// Создаем ссылку для скачивания файла в браузере
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', `products.xlsx`);
				document.body.appendChild(link);
				link.click();

				// Удаляем ссылку после скачивания файла
				URL.revokeObjectURL(fileUrl);
			}
			return
		}

		if (`/products${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams
		var response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data, 'size': filterDataCopy.size })
		}

		setDropdownIsOpen(false)
	}

	async function updateCostPrice(e) {
		e.preventDefault();

		var response = await PUT('/products-change-price', {
			'pos_id': reduxAccount.pos_id,
			'product_id': selectedItem.id,
			'cost_price': selectedItem.cost_price,
			'sale_price': selectedItem.sale_price,
		}, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalCostPrice()
		}
	}

	async function downloadExcelRecipeFile() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/products-ingredients-excel"
		var urlParams = ""
		checkFilter()

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.menu_id >= 0)
			urlParams += returnSign(urlParams) + 'menu_id=' + filterDataCopy.menu_id
		if (filterDataCopy.in_product >= 0)
			urlParams += returnSign(urlParams) + 'in_product=' + filterDataCopy.in_product
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		filterUrl += urlParams

		var response = await FILE_D(filterUrl)
		if (httpOk(response)) {
			// Создаем объект Blob из полученного файла
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

			// Создаем ссылку для скачивания файла
			const fileUrl = URL.createObjectURL(file);

			// Создаем ссылку для скачивания файла в браузере
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', `${t('recipe')}.xlsx`);
			document.body.appendChild(link);
			link.click();

			// Удаляем ссылку после скачивания файла
			URL.revokeObjectURL(fileUrl);
		}
	}

	function resetFilter() {
		setFilterData({
			pos_id: null,
			search: '',
		})
		searchWithFilter()
		setFilterDataExist(false)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function toggleModalCostPrice(bool, item = {}) {
		setSelectedItem(item)
		setModalCostPrice(bool)
	}

	async function paginate(page) {
		setFilterData({ ...filterData, 'page': page })
	}

	async function deleteItem() {
		const response = await DELETE('/products', { 'id': deleteModalParams.id }, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function restoreItem(item) {
		var sendData = { ...item }
		sendData.id = item.id
		sendData.status = 1
		var response = await PUT('/products-status', sendData, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function importFromExel(e) {
		let formData = new FormData();
		formData.append("file", e.target.files[0]);

		var response = await FILE('/products-excel-import', formData, {}, { loader: true });

		if (httpOk(response)) {
			toast.success(t('success'))
			searchWithFilter()
		}

		document.getElementById('actual-btn').value = '';
	}

	async function exportToScale() {
		var response = await FILE_D('/products-export-scale')
		if (httpOk(response)) {
			// Создаем объект Blob из полученного файла
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

			// Создаем ссылку для скачивания файла
			const fileUrl = URL.createObjectURL(file);

			// Создаем ссылку для скачивания файла в браузере
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', `scale.txt`);
			document.body.appendChild(link);
			link.click();

			// Удаляем ссылку после скачивания файла
			URL.revokeObjectURL(fileUrl);
		}
	}

	async function getPoses() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) {
			setPoses(response.data)
			searchWithFilter()
		}
	}

	async function getMenu() {
		var response = await GET('/helper/menu')
		if (httpOk(response)) setMenu(response.data)
	}

	async function getPreparationPlaces(pos_id = null) {
		var filterPosId = pos_id ?? filterData.pos_id
		var response = await GET(`/helper/preparation-places?pos_id=${filterPosId}`)
		if (httpOk(response)) setPreparationPlaces(response.data)
	}

	async function getProductTypes() {
		const response = await GET(`/helper/product-types`)
		if (httpOk(response)) setProductTypes(response.data)
	}

	useEffect(() => {
		getPoses()
		getMenu()
		getProductTypes()
		getPreparationPlaces()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('products')} [{pagination?.response?.total}]
				</h4>
				<div className="d-flex gap-2">
					<Link className="btn-rounded btn btn-primary"
						to={`/products/create/${filterData.pos_id}`}>
						{t('create')}
					</Link>
					<DropdownButton title={t('action')}>
						<Dropdown.Item as="li" eventKey="1">
							<input id="actual-btn" hidden type="file" onChange={importFromExel} accept=".xlsx, application/vnd.ms-excel" />
							<label htmlFor="actual-btn" className="upload-from-excel">{t('import')}</label>
						</Dropdown.Item>
						<Dropdown.Item as="li" eventKey="2">
							<a href="https://download.kingplovv.uz/files/products_template.xlsx" className="upload-from-excel">
								{t('download_template')}
							</a>
						</Dropdown.Item>
						<Dropdown.Item eventKey="3">
							<div onClick={exportToScale}>
								{t('export_scale')}
							</div>
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => {
														setFilterData({ ...filterData, 'pos_id': option.id })
														getPreparationPlaces(option.id)
													}}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('menu')}</label>
												<Select
													isClearable
													options={menu}
													value={menu.find(option => option.id === filterData.menu_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'menu_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('type')}</label>
												<Select
													isClearable
													options={productTypes}
													value={productTypes.find(option => option.id === filterData.in_product) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'in_product': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('preparation_places')}</label>
												<Select
													isClearable
													options={preparationPlaces}
													value={preparationPlaces.find(option => option.id === filterData.preparation_place_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'preparation_place_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('products_without')}</label>
												<Select
													isClearable
													options={columnFilers}
													value={columnFilers.find(option => option.id === filterData.product_without) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'product_without': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('page_size')}</label>
												<Select
													options={PAGE_SIZES}
													value={PAGE_SIZES.find(option => option.id === filterData.size) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'size': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('sorting')}</label>
												<Select
													isClearable
													options={columnOrders}
													value={columnOrders.find(option => option.id === filterData.order_by) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'order_by': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="d-flex justify-content-end gap-2">
											<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
											<button className="btn btn-primary" onClick={() => searchWithFilter()}>{t('apply')}</button>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div className="d-flex gap-2">
								<button className="btn btn-outline-primary btn-wide"
									onClick={() => downloadExcelRecipeFile()}>
									{t('recipes')}
								</button>
								<button className="btn btn-outline-primary btn-wide-2"
									onClick={() => searchWithFilter({ 'excel': true })}>
									<CustomTooltip text={t('EXCEL')}>
										<i className="uil uil-file-download-alt"></i>
									</CustomTooltip>
								</button>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.menu_id &&
									<span className="me-2">
										<b>{t('menu')}: </b>
										{findKeyFromArrayByValue(menu, 'id', filterData.menu_id, 'name')}
									</span>
								}
								{filterData.preparation_place_id &&
									<span className="me-2">
										<b>{t('preparation_places')}: </b>
										{findKeyFromArrayByValue(preparationPlaces, 'id', filterData.preparation_place_id, 'name')}
									</span>
								}
								{filterData.in_product >= 0 &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{findKeyFromArrayByValue(productTypes, 'id', filterData.in_product, 'name')}
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }} className="text-end td-ellipsis">{t('cost_price')}</th>
									<th style={{ 'width': '10%' }} className="text-end td-ellipsis">{t('sale_price')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('markup')}</th>
									<th style={{ 'width': '5%' }} className="text-end">
										<CustomTooltip text={`100 / ${t('sale_price')} * 100`}>
											Фудкост%
										</CustomTooltip>
									</th>
									<th style={{ 'width': '10%' }} className="text-end">
										<CustomTooltip text={`(${t('sale_price')} - ${t('cost_price')}) / ${t('sale_price')} * 100`}>
											{t('margin')}%
										</CustomTooltip>
									</th>
									<th style={{ 'width': '5%' }} className="text-center td-ellipsis"
										title={t('price')}>
										{t('price')}
									</th>
									<th style={{ 'width': '5%' }} className="text-center td-ellipsis"
										title={t('image2')}>
										{t('image2')}
									</th>
									<th style={{ 'width': '5%' }} className="text-center td-ellipsis"
										title={t('ingredients')}>
										{t('ingredients')}
									</th>
									<th style={{ 'width': '5%' }} className="text-center td-ellipsis"
										title={t('fiscalization')}>
										{t('fiscalization')}
									</th>
									<th style={{ 'width': '5%' }} className="text-center td-ellipsis"
										title={t('preparation_places')}>
										{t('preparation_places')}
									</th>
									<th style={{ 'width': '35px', 'minWidth': '35px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">
											<CustomTooltip text={item.id}>
												{item.row_number}
											</CustomTooltip>
										</td>
										<td>
											<Link to={`/products/update/${filterData.pos_id}/${item.id}`} target="_blank" rel="noopener noreferrer">
												{item.name}
											</Link>
										</td>
										<td className="text-end">{formatMoney(item.cost_price)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.income)}</td>
										<td className="text-end">
											{formatMoney(item.fc_percentage, 2)}
										</td>
										<td className="text-end">{formatMoney(item.margin, 2)}</td>
										<td className="text-center">
											<CustomTooltip text={`${t('cost_price')} > ${t('sale_price')}`}>
												{(Number(item.cost_price) > Number(item.sale_price)) &&
													<span className="bg-danger bg-border"></span>
												}
											</CustomTooltip>
											<CustomTooltip text={`${t('cost_price')} <= ${t('sale_price')}`}>
												{(Number(item.cost_price) <= Number(item.sale_price)) &&
													<span className="bg-primary bg-border"></span>
												}
											</CustomTooltip>
										</td>
										<td className="text-center">
											{!item.image &&
												<span className="bg-danger bg-border"></span>
											}
											{item.image &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td className="text-center">
											{!item.has_ingredients &&
												<span className="bg-danger bg-border"></span>
											}
											{item.has_ingredients &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td className="text-center">
											{!item.fiscal_code &&
												<span className="bg-danger bg-border"></span>
											}
											{item.fiscal_code &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td className="text-center">
											{!item.has_preparation_place &&
												<span className="bg-danger bg-border"></span>
											}
											{item.has_preparation_place &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Link to={`/products/update/${filterData.pos_id}/${item.id}`} className="table-dropdown-item">
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</Link>
														<div className="table-dropdown-item"
															style={{ 'lineHeight': '12px' }}
															onClick={() => toggleModalCostPrice(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('set_cost_price_manually')}
														</div>
														{item.status === 1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
														{item.status === -1 &&
															<div className="table-dropdown-item"
																onClick={() => restoreItem(item)}>
																<i className="uil-history-alt"></i>
																{t('restore')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL CREATE */}
			<Modal show={modalCostPrice} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModalCostPrice()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('edit')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => updateCostPrice(e)} autoComplete="off">
						<div className="form-group w-100">
							<label>{t('cost_price')}</label>
							<input type="number" className="form-control" name="cost_price"
								value={selectedItem.cost_price ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'cost_price': e.target.value })} />
						</div>
						<div className="form-group w-100">
							<label>{t('sale_price')}</label>
							<input type="number" className="form-control" name="sale_price"
								value={selectedItem.sale_price ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'sale_price': e.target.value })} />
						</div>

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCostPrice(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index